<script>
	import { capitalizeString } from '@resider/utils';

	export let userPicture = '';
	export let userName = '';
</script>

{#if userPicture}
	<img src={userPicture} alt={userName} />
{:else if userName}
	{#if userName?.length}
		<span class="initials">
			{capitalizeString(
				userName
					.split(' ')
					.map((name) => name[0])
					.join('')
			)}
		</span>
	{/if}
{:else}
	<svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
		<rect width="40" height="40" rx="20" fill="#D4D4D4" />
		<path
			d="M4 40V37.75C4 29.0515 11.1635 22 20 22C28.8366 22 36 29.0515 36 37.75V40"
			fill="white"
		/>
		<path
			d="M19.9999 24C24.9704 24 29 19.9705 29 15C29 10.0294 24.9705 6 20 6C15.0294 6 11 10.0294 11 15C11 19.9705 15.0293 24 19.9999 24Z"
			fill="white"
		/>
	</svg>
{/if}

<style>.initials,img,svg{height:2rem;height:var(--size, 2rem);width:2rem;width:var(--size, 2rem)}img,svg{border:2px solid hsla(var(--hsl-primary));border-radius:1rem}.initials{background:hsla(var(--hsl-primary));color:hsla(var(--hsl-white));border-radius:100%;display:grid;align-content:center;justify-content:center;place-content:center;font-size:calc(var(--size)/2.5);font-weight:600}</style>
